// src/app/admin/views/company/view-trainers/view-trainers.component.ts

import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmEventType, ConfirmationService, Message, MessageService } from 'primeng/api';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-view-trainers',
  templateUrl: './view-trainers.component.html',
  styleUrls: ['./view-trainers.component.scss'],
  providers: [MessageService]
})
export class ViewTrainersComponent {
  header = this.translate('Trainers');
  links: link[] = [
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Trainers'),  link: '/trainers', },
  ];
  stats: stat[] = [];
  messages: Message[] = [];
  skeleton = true
  data: any[] = [];

  tabs: any[] = [
    { name: this.translate('Internal'), value: 'Internal' },
    { name: this.translate('External'), value: 'External' }
  ];

  typeFlag : any = 'Internal'
  addTrainer = false
  trainerData : any = []
  companyData : any  = []
  companyFilter : any = null

  showRatingGraph: boolean = false;
  ratingUserID: string = '';

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  
  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    private router: Router,
  ) { }


  changeRoute(route:any){
    this.router.navigate([route]);

  }

  ngOnInit() {
    this.getTrainers();
    this.getCompanies()
  }


  async getCompanies(){
    try {
      let res = await this.dataService.getData('company')
      if(res.error) return
      this.companyData = res.data
    } catch (error) {
      console.log(error)
    }
  }


  getTrainers = async () => {
    try {
      
      this.skeleton = true
      let query : any 
      if(this.typeFlag == 'Internal'){
        query = {
          'externalUser.status' : { $ne: true },
          'externalUser.role' : 'trainer'
        }
      }
      if(this.typeFlag == 'External'){
        query = {
          'externalUser.status' :  true ,
          'externalUser.role' : 'trainer'
        }
        if(this.companyFilter != null) {
          query['externalUser.company'] = this.companyFilter._id
        }
      }
      let res = await this.dataService.postData('user/get',query);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.trainerData = res.data
      this.skeleton = false;
    
    } catch (error) {
      console.log(error);
    }
  };

  refreshFilters(){
    this.companyFilter = null
    this.getTrainers()
  }


  confirmDeleteTrainer(id:string){
    this.confirm({
      message: this.translate('Are you sure you want to approve this comment?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.deleteTrainer(id),
    });
  }

  setratingUserID(id:string){
    this.showRatingGraph = true;
    this.ratingUserID = id;
  }

  async deleteTrainer(id:string){
    try {
    
      let data = {
        _id : id,
        "externalUser.role" : null
      }

      let response = await this.dataService.postData('user/',data,'PUT',false)
      if(response.error){
        return
      }
      else this.getTrainers();      
    } catch (error) {
      console.log(error)
    }
  }

  async assNewTrainers(list : any){
    if(list.emit == false){
      this.addTrainer = false
    }
    const arrayOfIds = list.users.map((obj:any) => obj._id);
    try {
      let res :any = this.dataService.postData('user/add-trainer',arrayOfIds,'PUT',false);
      if(res.error) {
        return
      }  
      else {
        this.addTrainer = false
        this.getTrainers();
      }
    } catch (error) {
      console.log(error)
    }
  }


  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: this.translate('Yes'),
      rejectLabel: this.translate('no'),
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

}
